import { render, staticRenderFns } from "./addTwo.vue?vue&type=template&id=4d754e1a&scoped=true"
import script from "./addTwo.vue?vue&type=script&lang=js"
export * from "./addTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d754e1a",
  null
  
)

export default component.exports